<!-- Footer -->
<footer class="page-footer font-small blue pt-4">
    <!-- Copyright -->
    <div class="footer-copyright text-center py-3">Versión Push: {{pushVersion}} © {{pushAnio}} Copyright:
      <a target="_blank" href="https://proseso.mx/"> Proseso Consultores S.A de C.V </a>
    </div>
  <!-- Copyright -->
  
  </footer><!-- Footer -->